<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Hilos</h2>
          <p>En este apartado se pueden gestionar los hilos.</p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de hilos</h3>
              <v-server-table
                name="colors"
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{ name: 'AdminColorsNewScreen' }"
                    >Nuevo hilo</b-button
                  >

                  <b-button
                    variant="outline-danger"
                    class="ml-2"
                    @click="removeSelected()"
                    :disabled="table.selected.length === 0"
                    >Eliminar seleccionados</b-button
                  >
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.id)"
                    @change="toggleCell($event, props.row.id)"
                  />
                </div>

                <template v-slot:preview="props">
                  <img
                    style="max-height: 100px; max-width: 100px"
                    :src="props.row.icon"
                  />
                </template>

                <template v-slot:code_hex="props">
                  <div
                    :style="{
                      float: 'left',
                      height: '25px',
                      marginRight: '0.5rem',
                      width: '25px',
                      border: '1px solid #CCC',
                      padding: '0.25rem',
                      backgroundColor: '#' + props.row.code_hex,
                    }"
                  ></div>
                  <span>#{{ props.row.code_hex }}</span>
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminColorsEditScreen',
                      params: { id: props.row.id },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Editar</b-button
                  >

                  <b-button
                    @click="removeColor(props.row.id)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    >Eliminar</b-button
                  >
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'AdminColorsScreen',
  props: {},
  components: {},
  data() {
    return {
      table: {
        url: uris.colorsURI,
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'reference',
          'provider',
          'ref_provider',
          'code_hex',
          'preview',
          'actions',
        ],
        options: {
          saveState: true,
          sortable: ['reference'],
          headings: {
            reference: 'Nombre de hilo',
            name_es: 'Nombre',
            ref_provider: 'Ref. proveedor',
            provider: 'Proveedor',
            code_hex: 'Color (código hexadecimal)',
            preview: 'Vista previa',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeColor(x);
      });
    },
    removeColor(id) {
      actions.deleteColor(id).then((x) => {
        this.$refs.table.refresh();
      });
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.id)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
